import { TableColumnsType } from 'antd';
import { TFunction } from 'i18next';
import { ICleanupDataItem } from '@/models/akeneoSync.model';
import { renderDate } from '@/utils';
import { DateFormats } from '@/constants/dates';

export const getCleanupDatabaseTableColumns = (t: TFunction): TableColumnsType<ICleanupDataItem> => [
  {
    title: t('channel_name_usage'),
    dataIndex: 'channelSlug',
    key: 'channelSlug',
    render: (channel: string) => channel,
  },
  {
    title: t('label_status'),
    dataIndex: 'status',
    key: 'status',
    render: (status: string) => status,
  },
  {
    title: t('label_start_date'),
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (createdAt?: string) => (createdAt ? renderDate(createdAt, DateFormats.DATE_WITH_TIME) : '-'),
  },
  {
    title: t('label_planned_count'),
    dataIndex: 'candidatesToDelete',
    key: 'candidatesToDelete',
    render: (value?: number) => value ?? 0,
  },
  {
    title: t('label_local_count'),
    dataIndex: 'localCount',
    key: 'localCount',
    render: (value?: number) => value ?? 0,
  },
  {
    title: t('label_akeneo_count'),
    dataIndex: 'akeneoCount',
    key: 'akeneoCount',
    render: (value?: number) => value ?? 0,
  },
  {
    title: t('label_already_removed'),
    dataIndex: 'deletedCount',
    key: 'deletedCount',
    render: (value?: number) => value ?? 0,
  },
  {
    title: t('label_failed_count'),
    dataIndex: 'failedCount',
    key: 'failedCount',
    render: (value?: number) => value ?? 0,
  },
];
